module.exports = __webpack_public_path__ + "static/hero6-094efbe44069f1cd91ae5c0111088aa0.jpg";